// import { DataSource } from 'ng2-smart-table/lib/lib/data-source/data-source';
import { Observable } from 'rxjs';
import { has, isNil, isObject, isString, find, isEmpty,  } from 'lodash';

import { DataSource, ServerDataSource } from 'angular2-smart-table';
// import { ViewCell } from 'ng2-smart-table';
import { Model } from './common/.base.model';
import { Author } from './author';
import { Person } from './person';
import { JobPosting } from './job-posting';
import { EntityConfigTemplate } from './common/entity-config.interface';
import { FormConfigTemplate } from './common/form-config-template.interface';

export interface Department extends Model {
  name: string;
  description?: string;
  people: Person[];
  manager: Person;
  jobPostings: JobPosting[];
}

export const DepartmentConfig: EntityConfigTemplate = {
  meta: { entityName: 'department', entityPluralName: 'departments', titleField: 'name', view: false },
  name: { title: 'Name' },
  description: { title: 'Description' },
  manager: { isForeignKey: true, title: 'Manager', filters: { employmentStatus: { $ne: "applicant" }}, valuePrep: (_cell_, row) => `${row?.manager?.firstName ?? ''} ${row?.manager?.lastName ?? ''}` },
  people: { isForeignKey: true, multiSelect: true, title: 'People', valuePrep: (_cell_, row) => `${row?.people?.length | 0}` },
  jobPostings: { isForeignKey: true, title: 'Job Postings', valuePrep: (_cell_, row) => `${row?.jobPostings?.length | 0}` },
};

export const DepartmentFormConfig: FormConfigTemplate = {
  tabs: [
    {
      title: "Department Details",
      columns: [
        {
          size: "col-12",
          type: "form",
          sections: [
            {
              title: "Department Details",
              rows: [
                {
                  fields: [
                    { name: "name", label: "Name", type: "text", required: true, size: "col-6" },
                    { name: "manager", label: "Manager", type: "selectRelation", entityName: "person", size: "col-6" },
                  ]
                },
                {
                  fields: [
                    { name: "description", label: "Description", type: "textarea", required: false, size: "col-12" },
                    { name: "people", multiSelect: true, label: "People", type: "selectRelation", entityName: "person", size: "col-6" },
                  ] 
                }
              ],
            }
          ],
        },
      ],
    },
  ],
};

export abstract class DepartmentData {
  abstract get gridDataSource(): ServerDataSource;
  abstract list(pageNumber: number, pageSize: number): Observable<Department[]>;
  abstract listAll(): Observable<Department[]>;
  abstract get(id: string): Observable<Department>;
  abstract update(Department: Department): Observable<Department>;
  abstract create(Department: Department): Observable<Department>;
  abstract delete(id: string): Observable<boolean>;
  
}




